/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Extract_DataInputs */



/**
* | output |
* | --- |
* | "Pull the key data out of a document" |
*
* @param {Uno_Welcome_Suggestion_Extract_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_extract_data = /** @type {((inputs?: Uno_Welcome_Suggestion_Extract_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Extract_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die wichtigsten Daten aus einem Dokument herausziehen")
	return /** @type {LocalizedString} */ ("Pull the key data out of a document")
});